import React, { useEffect, useRef } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginUser } from "../loginSlice";
import "./login.css";
import { setBackButtonUrl } from "../uiSlice";
import Swal from "sweetalert2";
import { getThemeAssetUrl, themeBackgroundKeyForViewport, toCssUrlValue } from "../../functions/themeAssets";

function Login() {
  const dispatch = useDispatch();
  const { status, user, error } = useSelector((state) => state.auth);
  const { status: themeStatus, data: themeData } = useSelector(
    (state) => state.theme
  );

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isAdmin = searchParams.get("admin") === "true";
  // Same rule as the PHP side: isset($_GET["fromMobileApp"]) -> any value counts
  const fromMobileApp = searchParams.has("fromMobileApp");

  useEffect(() => {
    dispatch(loginUser());
  }, [dispatch]);

  useEffect(() => {
    if (status === "succeeded" && user && isAdmin) {
      navigate("/admin");
    }
  }, [status, user, isAdmin, navigate]);

  useEffect(() => {
    console.log("user",user);
    if (status === "succeeded" && user.backButtonRedirect) {
      dispatch(setBackButtonUrl(user.backButtonRedirect));
    }

  }, [status, user]);



 useEffect(() => {
  if (status !== "failed") return;
  const msg = error ? String(error) : "Session expired";
  const redirect = user && user.backButtonRedirect ? user.backButtonRedirect : "/";
  Swal.fire("Session Expired!", msg, "error").then(() => {
    window.location.href = redirect;
  });
}, [status, error, user]);

  // Disclaimer: shown once on the index page, only when opened from the mobile app
  const disclaimerShown = useRef(false);
  useEffect(() => {
    if (isAdmin || disclaimerShown.current || !fromMobileApp) return;
    if (status !== "succeeded" || !user || !themeData) return;
    disclaimerShown.current = true;

    const bgKey = themeBackgroundKeyForViewport(themeData);
    const bgImage = bgKey ? getThemeAssetUrl(bgKey) : "";
    const textColor = themeData.text_color ?? "#000000";
    const buttonColor = themeData.button_color ?? "#6b91e8";
    const buttonTextColor = themeData.button_text_color ?? "#ffffff";

    Swal.fire({
      title: "Disclaimer",
      html:
        "<p>This bingo game is provided solely for entertainment and engagement. No real money, betting, deposits, withdrawals, or cash transactions are involved. All cards, points, coins, and rewards are virtual.</p>" +
        "<p>Apple Inc. is not a sponsor of, affiliated with, or involved in this Fullhouse in any manner.</p>",
      confirmButtonText: "OK",
      allowOutsideClick: false,
      backdrop: "rgba(10, 10, 20, 0.35)",
      color: textColor,
      confirmButtonColor: buttonColor,
      customClass: {
        popup: "fullhouse-swal-popup",
        confirmButton: "fullhouse-swal-confirm-btn",
      },
      didOpen: (popup) => {
        const btn = popup.querySelector(".swal2-confirm");
        if (btn) btn.style.color = buttonTextColor;
        if (bgImage) {
          popup.style.backgroundImage = toCssUrlValue(bgImage);
          popup.style.backgroundSize = "cover";
          popup.style.backgroundPosition = "center";
        }
      },
    });
  }, [isAdmin, fromMobileApp, status, user, themeData]);

  if (status === "loading" || themeStatus === "loading") {
    return (
      <div className="login-main-container">
        <div className="quiz-loader-container">
          <div className="quiz-loader"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-main-container">
      {themeData && (
        <img
          src={getThemeAssetUrl(themeData.logo)}
          className="login-logo"
          alt="Game Logo"
        />
      )}
        {user && status === "succeeded" && (
          <div>
            <Link
              to="/rules"
              className="begin-play-btn"
              style={{
                ...(themeData?.button_color && { backgroundColor: themeData.button_color }),
                ...(themeData?.button_text_color && { color: themeData.button_text_color }),
              }}
            >
              BEGIN PLAY
            </Link>
          </div>
        )}
    </div>
  );
}

export default Login;
